module.exports = __webpack_public_path__ + "img/inco2Ac.30846209.png";